import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import isVisible from 'ally.js/is/visible';
import classnames from 'classnames';
import * as focusTrap from 'focus-trap';
import React__default, { useRef, useEffect } from 'react';
import { focusFirstDescendant } from './FocusUtils.js';

var _excluded = ["as", "className", "children", "active", "onEscape", "onKeyUp", "hidden", "returnFocusTo", "contentClassName", "data-testid"];
var COMPONENT_CLASS = 'C-FocusTrap';
var FocusTrap = function FocusTrap(_ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'dialog' : _ref$as,
    className = _ref.className,
    children = _ref.children,
    active = _ref.active,
    onEscape = _ref.onEscape,
    onKeyUp = _ref.onKeyUp;
    _ref.hidden;
    var returnFocusTo = _ref.returnFocusTo,
    contentClassName = _ref.contentClassName,
    dataTestId = _ref['data-testid'],
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var contentRef = useRef();
  var dialogRef = useRef();

  // Constrains focus within <FocusTrap> when active
  useEffect(function () {
    if (active) {
      var element = dialogRef.current;
      if (isVisible(element)) {
        var trap = focusTrap.createFocusTrap(element, {
          allowOutsideClick: true,
          escapeDeactivates: false,
          fallbackFocus: returnFocusTo || document.body
        });
        trap.activate();
        focusFirstDescendant(element);
        return function () {
          trap.deactivate();
          if (returnFocusTo) {
            returnFocusTo.focus();
          }
        };
      }
    }
  }, [active, returnFocusTo]);
  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (active) {
        e.stopPropagation();
      }
      onEscape && onEscape(e);
    }
    onKeyUp && onKeyUp(e);
  };
  var finalClasses = classnames(COMPONENT_CLASS, className);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement(Component, _extends({}, otherProps, {
      onKeyUp: handleKeyUp,
      className: finalClasses,
      open: active,
      "data-testid": "focus_trap",
      ref: dialogRef
    }), /*#__PURE__*/React__default.createElement("div", {
      "data-testid": dataTestId,
      className: contentClassName,
      ref: contentRef
    }, children))
  );
};

export { FocusTrap as default };
